import { init, type RematchDispatch, type RematchRootState } from '@rematch/core';

import models, { type RootModel } from '@/app-state/models';

const initializeStore = (initialState = {}) => {
  return init({
    models,
    redux: {
      initialState,
    },
  });
};

export type Store = ReturnType<typeof initializeStore>;
export type Dispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel>;

export default initializeStore;
